import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import Slider from 'react-slick';
import styles from './style.module.scss';
import '../../styles/_slick.scss';
import { Row, Col } from 'reactstrap';
import Text from '../Text';
import arrowLeft from '../icons/slick/left.svg';
import arrowRight from '../icons/slick/right.svg';
import { FigureImage, Link } from '@jobmatchme/ui';

var Testimonials = /*#__PURE__*/function (_Component) {
  _inherits(Testimonials, _Component);

  function Testimonials(props) {
    var _this;

    _classCallCheck(this, Testimonials);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Testimonials).call(this, props));

    _this.updateWindowDimensions = function () {
      _this.setState({
        slidesToShow: _this.getSlidesToShow()
      });
    };

    _this.renderChildren = function (children, variant, layout) {
      return React.Children.map(children, function (child, index) {
        return React.cloneElement(child, {
          variant: variant,
          key: index,
          numericDots: _this.props.numericDots,
          contentNavi: _this.props.contentNavi,
          layout: layout
        });
      });
    };

    _this.next = function () {
      _this.slider.slickNext();

      _this.scrollTo();
    };

    _this.scrollTo = function () {
      if (_this.props.scrollToContent) {
        var element = document.getElementById(_this.props.contentId);

        if (element) {
          // element.scrollIntoView({ behavior: "smooth", block: "end" }) buggy
          element.scrollIntoView();
        }
      }
    };

    _this.previous = function () {
      _this.slider.slickPrev();

      _this.scrollTo();
    };

    _this.getNumericDotClass = function (i) {
      return styles.numericDot + (i === _this.state.activeSlide ? " ".concat(styles.numericDotActive) : '');
    };

    _this.numericDotSettings = function () {
      return {
        customPaging: function customPaging(i) {
          return React.createElement("span", {
            className: _this.getNumericDotClass(i)
          }, React.createElement("span", {
            onClick: _this.scrollTo
          }, i + 1));
        },
        appendDots: function appendDots(dots) {
          return React.createElement("ul", null, React.createElement("li", {
            className: styles.arrow,
            onClick: _this.previous
          }, React.createElement("img", {
            src: arrowLeft,
            alt: "<-"
          })), dots, React.createElement("li", {
            className: styles.arrow,
            onClick: _this.next
          }, React.createElement("img", {
            src: arrowRight,
            alt: "->"
          })));
        },
        beforeChange: function beforeChange(current, next) {
          return _this.beforeChange(next);
        }
      };
    };

    _this.beforeChange = function (next) {
      _this.setState({
        activeSlide: next
      });
    };

    _this.getSlidesToShow = function () {
      return _this.props.slidesToShow ? window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : _this.props.slidesToShow : 1;
    };

    _this.state = {
      activeSlide: 0,
      slidesToShow: _this.getSlidesToShow()
    };
    return _this;
  }

  _createClass(Testimonials, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var settings = _objectSpread({
        dots: true,
        arrows: this.props.arrows || false,
        dotsClass: "".concat(styles.dots, " ").concat(styles[this.props.variant]),
        autoplay: this.props.noAutoplay ? false : true,
        infinite: true,
        speed: 1000,
        slidesToShow: this.state.slidesToShow,
        slidesToScroll: 1,
        autoplaySpeed: this.props.autoplaySpeed ? this.props.autoplaySpeed : 5000,
        className: this.props.layout !== 'bc-success-story' ? styles.slider : ''
      }, this.props.numericDots ? this.numericDotSettings() : {}, this.props.adaptiveHeight && {
        adaptiveHeight: true
      });

      return React.createElement("div", {
        className: styles.wrapper
      }, React.createElement(Slider, Object.assign({
        ref: function ref(c) {
          return _this2.slider = c;
        }
      }, settings), this.renderChildren(this.props.children, this.props.variant, this.props.layout, this.props.key)));
    }
  }]);

  return Testimonials;
}(Component);

Testimonials.defaultProps = {
  variant: '',
  arrows: false
};
/**
 * A slide element
 *
 * @param {React.Node}          children      The children slides
 * @param {content}             subline       A subline for the slide element
 * @param {string}              image         The testimonials image URL (Static)
 * @param {testimonialVariant}  variant       The components variant
 * @param {boolean}             padding       Wether or not to display padding on the image
 * @param {string}              link          The link for a read more link
 **/

var Element = function Element(_ref) {
  var children = _ref.children,
      subline = _ref.subline,
      image = _ref.image,
      variant = _ref.variant,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? false : _ref$padding,
      layout = _ref.layout,
      link = _ref.link;
  return React.createElement("div", {
    className: styles[variant]
  }, renderLayout(layout, image, padding, subline, children, link));
};

var renderImage = function renderImage(image, padding) {
  return image && React.createElement("figure", {
    className: styles.noLeft
  }, React.createElement("div", {
    className: "".concat(styles.imageWrapper, " ").concat(padding && styles.padding)
  }, React.createElement("img", {
    src: image,
    alt: ""
  })));
};

var renderContent = function renderContent(children) {
  return React.createElement("span", {
    className: styles.content
  }, "\u201E", children, "\"");
};

var renderSubline = function renderSubline(subline) {
  return React.createElement("span", {
    className: styles.subline
  }, subline);
};

var renderLayout = function renderLayout(layout, image, padding, subline, children, link) {
  switch (layout) {
    case 'bc-testimonials':
      return React.createElement("div", {
        className: styles.bcTestimonials
      }, React.createElement("article", null, React.createElement(Row, null, React.createElement(Col, {
        md: "4",
        xs: "12"
      }, renderImage(image, padding), React.createElement(Text, null, renderSubline(subline))), React.createElement(Col, {
        md: "8",
        xs: "12"
      }, React.createElement(Text, null, renderContent(children))))));

    case 'bc-how':
      return React.createElement("article", null, React.createElement("div", {
        className: styles.bcHow
      }, React.createElement(Row, null, React.createElement(Col, {
        md: "6",
        xs: "12"
      }, renderSubline(subline), React.createElement("div", {
        className: styles.content
      }, React.createElement(Text, null, children))), React.createElement(Col, {
        md: "6",
        xs: "12"
      }, renderImage(image, padding)))));

    case 'bc-help':
      return React.createElement("div", {
        className: styles.bcHelp
      }, React.createElement(Row, null, React.createElement(Col, {
        md: "6",
        xs: "12"
      }, renderSubline(subline), React.createElement("div", {
        className: styles.content
      }, React.createElement(Text, null, children))), React.createElement(Col, {
        md: "6",
        xs: "12"
      }, renderImage(image, padding))));

    case 'bc-success-story':
      return React.createElement("article", null, React.createElement("div", {
        className: styles.bcSuccessStory
      }, React.createElement(Row, null, React.createElement(Col, {
        xs: "12"
      }, React.createElement(FigureImage, {
        src: image,
        alt: "Erfahrungen mit Truckjobs",
        description: subline,
        textAlign: 'center',
        cutted: false
      })), React.createElement(Col, {
        xs: "12"
      }, React.createElement(Text, {
        className: styles.teaserText
      }, renderContent(children)), React.createElement("div", {
        className: styles.linkWrapper
      }, React.createElement(Link, {
        to: link
      }, "Weiterlesen"))))));

    case 'bc-support':
      return React.createElement("div", {
        className: styles.bcTestimonials
      }, React.createElement("article", null, React.createElement(FigureImage, {
        src: image,
        alt: "Erfahrungen mit Truckjobs",
        description: subline,
        textAlign: 'center',
        cutted: false,
        maxWidth: "100%"
      })));

    default:
      return React.createElement(React.Fragment, null, renderImage(image, padding), renderContent(children), renderSubline(subline));
  }
};

Testimonials.Element = Element;
export { Testimonials };
export default Testimonials;